export default __webpack_public_path__ + "static/media/image-2.5a390b69.png";